import { Mark } from "@tiptap/core";

// This file defines a Tiptap extension for setting font size in a rich text editor.
// It allows users to apply different font sizes to text within the editor.
export const FontSize = Mark.create({
  name: "fontSize",

  // This extension is used to style text with different font sizes.
  // It can be applied to text nodes in the editor.
  addOptions() {
    return {
      types: ["textStyle"],
    };
  },

  // This method defines the attributes that can be set for this mark.
  // In this case, it allows setting a font size.
  addAttributes() {
    return {
      fontSize: {
        default: null,
        parseHTML: (element) => element.style.fontSize || null,
        renderHTML: (attributes) => {
          if (!attributes.fontSize) return {};
          return { style: `font-size: ${attributes.fontSize}` };
        },
      },
    };
  },

  // This method defines how the mark should be parsed from HTML.
  // It looks for the 'style' attribute to extract the font size.
  parseHTML() {
    return [
      {
        style: "font-size",
      },
    ];
  },

  // This method defines how the mark should be rendered in HTML.
  // It creates a 'span' element with the appropriate styles.
  renderHTML({ HTMLAttributes }) {
    return ["span", HTMLAttributes, 0];
  },

  // This method adds commands to the editor for setting and unsetting the font size.
  // It allows users to change the font size of selected text.
  addCommands() {
    return {
      setFontSize:
        (fontSize) =>
        ({ chain }) => {
          return chain().setMark(this.name, { fontSize }).run();
        },
      unsetFontSize:
        () =>
        ({ chain }) => {
          return chain().unsetMark(this.name).run();
        },
    };
  },
});
